import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "w-full mt-4 fac-box p-3" }
const _hoisted_2 = { class: "w-full flex items-center" }
const _hoisted_3 = {
  class: "freqx_formTitle",
  style: {"width":"200px"}
}
const _hoisted_4 = { class: "w-full flex flex-wrap" }
const _hoisted_5 = {
  class: "facInfo p-4",
  style: {"padding-top":"5px"}
}
const _hoisted_6 = { class: "w-full flex mb-2" }
const _hoisted_7 = { class: "cursor-pointer" }
const _hoisted_8 = { class: "w-full flex items-center" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "w-full flex items-center mt-3" }
const _hoisted_11 = { class: "w-full mt-4 fac-box p-3" }
const _hoisted_12 = { class: "w-full flex items-center" }
const _hoisted_13 = { class: "freqx_formTitle fff" }
const _hoisted_14 = { class: "w-full" }
const _hoisted_15 = { class: "code-box-meta markdown" }
const _hoisted_16 = { class: "code-box-title" }
const _hoisted_17 = { class: "code-box-description" }
const _hoisted_18 = { class: "w-full mt-4 fac-box p-3" }
const _hoisted_19 = { class: "w-full flex items-center" }
const _hoisted_20 = { class: "freqx_formTitle fff" }
const _hoisted_21 = { class: "w-full" }
const _hoisted_22 = { class: "code-box-meta markdown" }
const _hoisted_23 = {
  class: "code-box-title",
  style: {"background":"#080718ff"}
}
const _hoisted_24 = { class: "code-box-description" }
const _hoisted_25 = { class: "flex" }
const _hoisted_26 = { class: "code-box-description" }
const _hoisted_27 = { class: "fff" }
const _hoisted_28 = { class: "fff" }
const _hoisted_29 = { class: "fff" }
const _hoisted_30 = { class: "fff" }
const _hoisted_31 = { class: "code-box-description" }
const _hoisted_32 = { class: "fff" }
const _hoisted_33 = { class: "fff" }
const _hoisted_34 = { class: "w-full mt-4 fac-box p-3" }
const _hoisted_35 = { class: "w-full flex items-center" }
const _hoisted_36 = {
  class: "freqx_formTitle fff",
  style: {"width":"200px"}
}
const _hoisted_37 = { class: "w-full" }
const _hoisted_38 = { class: "code-box-meta markdown" }
const _hoisted_39 = { class: "code-box-title" }
const _hoisted_40 = { class: "code-box-description" }
const _hoisted_41 = { class: "code-box-description" }
const _hoisted_42 = { class: "code-box-description" }
const _hoisted_43 = { class: "code-box-description" }
const _hoisted_44 = { class: "code-box-description" }
const _hoisted_45 = { class: "w-full mt-4 fac-box p-3" }
const _hoisted_46 = { class: "w-full flex items-center" }
const _hoisted_47 = { class: "freqx_formTitle fff" }
const _hoisted_48 = { class: "code-box-meta markdown" }
const _hoisted_49 = {
  class: "code-box-title",
  style: {"background":"#080718ff"}
}
const _hoisted_50 = { class: "code-box-description" }
const _hoisted_51 = { class: "flex" }
const _hoisted_52 = { class: "code-box-description" }
const _hoisted_53 = { class: "flex" }
const _hoisted_54 = { class: "fff" }
const _hoisted_55 = { class: "fff" }
const _hoisted_56 = { class: "fff" }
const _hoisted_57 = { class: "code-box-description" }
const _hoisted_58 = { class: "flex" }
const _hoisted_59 = { class: "fff" }
const _hoisted_60 = { class: "fff" }
const _hoisted_61 = { class: "code-box-description" }
const _hoisted_62 = { class: "flex" }
const _hoisted_63 = { class: "fff" }
const _hoisted_64 = { class: "fff" }
const _hoisted_65 = { class: "code-box-description" }
const _hoisted_66 = { class: "flex" }
const _hoisted_67 = { class: "fff" }
const _hoisted_68 = { class: "fff" }

import request from "../../common/request";
import { transformDate } from "@/common/tools";
import { onMounted } from "vue";
import { ref } from "vue";
import { v4 as uuidv4 } from "uuid";
import { message } from "ant-design-vue";
/**操作日志记录 */
import { operateLogs } from "@/common/logs";
import { getLanguage, getTranslation } from "@/common/translate";

interface FactorySettings {
  id?: string | null;
  factoryId: string | null;
  diagnosisRule: DiagnosisRule;
  reportRule: ReportRule;
  workWxSettings: WorkWxSettings;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'RuleSetting',
  setup(__props) {

operateLogs("访问基础配置");
/**操作日志记录 */

onMounted(() => {
  loadDatatype();
});

let dataTypes = ref<{ value: string; label: string }>();
const loadDatatype = () => {
  const config = {
    headers: {
      requestId: uuidv4(),
    },
  };
  request.get("/api/sensors/datatype", config).then((res: any) => {
    if (res) {
      dataTypes.value = res.data.map((t: any) => ({
        value: t.name,
        label: t.name,
      }));
    }
  });
};

class DiagnosisRule {
  defaultDataTypes: string[] = [];
}

class ReportRule {
  enabled: boolean = true;
  dayOfMonth: number = 1;
  dayOfWeek: number = 5;
  dayOfHour: number = 12;
}

class WorkWxSettings {
  messageTitle: string = "";
  chatId: string = "";
  agentId: string = "";
  corpId: string = "";
  corpSecret: string = "";
}

let factorySettingTabActiveKey = ref<any>(0);
let diagnosisForm = ref<
  Pick<FactorySettings, "id" | "factoryId" | "diagnosisRule">
>({
  id: null,
  factoryId: null,
  diagnosisRule: new DiagnosisRule(),
});
let onChangeFactorySettingTab = (key: number) => {
  let selectFact = factoryList.value[key];
  getFactorySettings(selectFact._id);
};

const getFactorySettings = (factoryId: string) => {
  const config = {
    params: { id: factoryId },
    headers: {
      requestId: uuidv4(),
    },
  };
  request.get("/api/factories/setting", config).then((res: any) => {
    if (res?.data?.diagnosisRule) {
      diagnosisForm.value = { ...res.data };
    } else {
      diagnosisForm.value = {
        factoryId: factoryId,
        diagnosisRule: new DiagnosisRule(),
      };
    }

    if (res?.data?.workWxSettings) {
      workWxForm.value = { ...res.data };
    } else {
      workWxForm.value = {
        factoryId: factoryId,
        workWxSettings: new WorkWxSettings(),
      };
    }

    if (res?.data?.reportRule) {
      reportRuleForm.value = { ...res.data };
    } else {
      reportRuleForm.value = {
        factoryId: factoryId,
        reportRule: new ReportRule(),
      };
    }
  });
};

const saveDiagnosisRules = () => {
  const config = {
    headers: {
      requestId: uuidv4(),
    },
  };

  diagnosisForm.value.factoryId =
    factoryList.value[factorySettingTabActiveKey.value]._id;

  request
    .post("/api/factories/setting", diagnosisForm.value, config)
    .then((res) => {
      if (res) {
        operateLogs("修改基础配置");
        message.success(getLanguage("操作成功"));
        getFactorySettings(diagnosisForm.value.factoryId!);
      }
    });
};

let factoryListAll: any = ref([]);
let boldList: any = ref([]);

let workWxForm = ref<
  Pick<FactorySettings, "id" | "factoryId" | "workWxSettings">
>({
  id: null,
  factoryId: null,
  workWxSettings: new WorkWxSettings(),
});

const saveWorkWxForm = () => {
  const config = {
    headers: {
      requestId: uuidv4(),
    },
  };
  workWxForm.value.factoryId =
    factoryList.value[factorySettingTabActiveKey.value]._id;

  request
    .post("/api/factories/setting", workWxForm.value, config)
    .then((res) => {
      if (res) {
        operateLogs("修改基础配置");
        message.success(getLanguage("操作成功"));
        getFactorySettings(workWxForm.value.factoryId!);
      }
    });
};

// 保存
const saveReportRuleSettings = () => {
  const config = {
    headers: {
      requestId: uuidv4(),
    },
  };

  reportRuleForm.value.factoryId =
    factoryList.value[factorySettingTabActiveKey.value]._id;

  request
    .post("/api/factories/setting", reportRuleForm.value, config)
    .then((res) => {
      if (res) {
        operateLogs("修改基础配置");
        message.success(getLanguage("操作成功"));
        getFactorySettings(reportRuleForm.value.factoryId!);
      }
    });
};

let reportRuleForm = ref<
  Pick<FactorySettings, "id" | "factoryId" | "reportRule">
>({
  id: null,
  factoryId: null,
  reportRule: new ReportRule(),
});
let factoryList = ref<any>();

let systemInfo = ref<any>({
  id: null,
  captcha: true,
  errorPwdLock: true,
  errorPwdCount: 3,
  errorPwdLockSecond: 300,
  autoLogout: true,
  autoLogoutSecond: 1800,
  pwdExpireDay: 180,
  pwdHistory: false,
  pwdHistoryDay: 180,
  opcUASettings: {
    url: "",
    userName: "",
    password: "",
  },
});

const loadFactory = () => {
  const config = {
    params: {},
    headers: {
      requestId: uuidv4(),
    },
  };
  request.get("/api/factories", config).then((res: any) => {
    if (res) {
      factoryListAll.value = JSON.parse(JSON.stringify(res.data));
      console.log("factoryListAll.value", factoryListAll.value);
      let childFactories = res.data.filter((t: any) => t.parentId);
      let parentIds = res.data
        .filter((t: any) => t.parentId)
        .map((t: any) => t.parentId);

      if (childFactories.length) {
        boldList.value = res.data.filter((t: any) => !t.parentId);
        factoryList.value = res.data.filter(
          (t: any) => !parentIds.includes(t._id)
        );
      } else {
        factoryList.value = res.data;
        boldList.value = factoryList.value;
      }
      getFactorySettings(factoryList.value[0]._id);
    }
  });
};

const deleteGroup = (list: any, index: any) => {
  list.splice(index, 1);
};

const addGroup = (list: any) => {
  list.push({
    sonID: new Date().getTime().toString(),
    name: "",
  });
};

const addFactory = () => {
  factoryListAll.value.push({
    createAt: transformDate(new Date()),
    factoryName: "",
    groups: [],
    parentId: "",
  });
};

const deleteFactory = async (index: any) => {
  let factory = factoryListAll.value[index];

  let children = factoryListAll.value.filter(
    (t: any) => t.parentId == factory._id
  );
  if (children.length) {
    message.warning("请先删除子工厂");
    return;
  }

  let res = await request.delete(`/api/factories`, {
    params: { id: factory._id },
  });
  if (res && res.status == 200) {
    message.success("删除工厂成功");
    factoryListAll.value.splice(index, 1);
    let idx = factoryList.value.findIndex((t: any) => t._id == factory._id);
    if (idx >= 0) {
      factoryList.value.splice(idx, 1);
    }
  }
};

const saveFactory = async () => {
  let list = JSON.parse(JSON.stringify(factoryListAll.value));

  for (let d of list) {
    if (!d.factoryName) {
      message.success("请填写工厂名称!");
      return;
    }
    if (d.groups && d.groups.length) {
      for (let g of d.groups) {
        if (!g.name) {
          message.success("请填写区域名称!");
          return;
        }
      }
    }
  }

  let result = await request.post("/api/factories", list);
  if (result && result.status == 200) {
    message.success(getLanguage("操作成功"));
    // 请求/api/member/info刷新人员的工厂权限缓存
    await request.get("/api/members/info");
    loadFactory();
  } else {
    message.success("操作失败");
  }
};

let loadSystemSetting = async () => {
  const config = {
    params: {},
    headers: {
      requestId: uuidv4(),
    },
  };
  let result = await request.get("/api/system/setting", config);
  if (result.data) {
    if (!result.data.opcUASettings) {
      result.data.opcUASettings = {
        url: "",
        userName: "",
        password: "",
      };
    }
    systemInfo.value = result.data;
  }
};

const saveSystemSetting = async () => {
  let result = await request.post("/api/system/setting", systemInfo.value);
  if (result && result.status == 200) {
    message.success(getLanguage("操作成功"));
    loadSystemSetting();
  } else {
    message.success("操作失败");
  }
};

onMounted(() => {
  loadFactory();
  loadSystemSetting();
});

return (_ctx: any,_cache: any) => {
  const _component_close_square_outlined = _resolveComponent("close-square-outlined")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_plus_outlined = _resolveComponent("plus-outlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_bank_outlined = _resolveComponent("bank-outlined")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_layout_content, { style: {"padding":"0 20px"} }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(getLanguage)('基础配置')), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(factoryListAll), (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                style: {"margin-right":"20px","width":"600px"},
                class: "mt-4",
                key: index
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _cache[23] || (_cache[23] = _createElementVNode("div", { class: "flex-1" }, null, -1)),
                    _createVNode(_component_a_popconfirm, {
                      title: "Delete this factory?",
                      "ok-text": "Confirm",
                      "cancel-text": "Cancel",
                      onConfirm: ($event: any) => (deleteFactory(index))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_7, [
                          _createVNode(_component_close_square_outlined, { style: {"font-size":"20px","margin-left":"10px","color":"#fff"} })
                        ])
                      ]),
                      _: 2
                    }, 1032, ["onConfirm"])
                  ]),
                  _createVNode(_component_a_form, {
                    "label-col": { span: 4 },
                    "wrapper-col": { span: 20 },
                    autocomplete: "off"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { label: "Parent Factory" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            ref_for: true,
                            ref: "select",
                            value: item.parentId,
                            "onUpdate:value": ($event: any) => ((item.parentId) = $event),
                            allowClear: ""
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(boldList), (item, index) => {
                                return (_openBlock(), _createBlock(_component_a_select_option, {
                                  key: index,
                                  value: item._id
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.factoryName), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["value", "onUpdate:value"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_a_form_item, { label: "Factory Name" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: item.factoryName,
                            "onUpdate:value": ($event: any) => ((item.factoryName) = $event)
                          }, null, 8, ["value", "onUpdate:value"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_a_form_item, { label: "Zone" }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.groups, (group, index2) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "w-full mt-2",
                              key: index2
                            }, [
                              _createElementVNode("div", _hoisted_8, [
                                _createVNode(_component_a_input, {
                                  value: group.name,
                                  "onUpdate:value": ($event: any) => ((group.name) = $event)
                                }, null, 8, ["value", "onUpdate:value"]),
                                _createVNode(_component_a_input, {
                                  style: {"margin-left":"10px"},
                                  value: group.sonID,
                                  "onUpdate:value": ($event: any) => ((group.sonID) = $event),
                                  readonly: ""
                                }, null, 8, ["value", "onUpdate:value"]),
                                _createElementVNode("div", {
                                  class: "cursor-pointer",
                                  onClick: ($event: any) => (deleteGroup(item.groups, index2))
                                }, [
                                  _createVNode(_component_close_square_outlined, { style: {"font-size":"20px","margin-left":"10px","color":"#fff"} })
                                ], 8, _hoisted_9)
                              ])
                            ]))
                          }), 128)),
                          _createVNode(_component_a_button, {
                            class: "mt-2",
                            style: {"background-color":"#fff"},
                            onClick: ($event: any) => (addGroup(item.groups))
                          }, {
                            icon: _withCtx(() => [
                              _createVNode(_component_plus_outlined)
                            ]),
                            default: _withCtx(() => [
                              _createTextVNode(" " + _toDisplayString(_unref(getLanguage)('新增')), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ])
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: addFactory
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(getLanguage)('新增')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_button, {
              class: "ml-2",
              type: "primary",
              onClick: saveFactory
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(getLanguage)('保存')), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_a_form, {
            model: _unref(diagnosisForm),
            name: "diagnosisForm",
            autocomplete: "off",
            layout: "inline",
            "label-col": { style: { width: '100px' } }
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(getLanguage)('设备诊断配置')), 1)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_a_tabs, {
                  activeKey: _unref(factorySettingTabActiveKey),
                  "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => (_isRef(factorySettingTabActiveKey) ? (factorySettingTabActiveKey).value = $event : factorySettingTabActiveKey = $event)),
                  onChange: _unref(onChangeFactorySettingTab)
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(factoryList), (item, key) => {
                      return (_openBlock(), _createBlock(_component_a_tab_pane, { key: key }, {
                        tab: _withCtx(() => [
                          _createElementVNode("span", null, [
                            _createVNode(_component_bank_outlined),
                            _createTextVNode(" " + _toDisplayString(_unref(getTranslation)(item.factoryName)), 1)
                          ])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["activeKey", "onChange"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(getLanguage)('指标监测')), 1),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_a_form_item, {
                    "label-col": { style: { width: '120px' } },
                    label: _unref(getLanguage)('默认数据类型'),
                    name: "defaultDataTypes"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        style: {"min-width":"500px"},
                        value: _unref(diagnosisForm).diagnosisRule.defaultDataTypes,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(diagnosisForm).diagnosisRule.defaultDataTypes) = $event)),
                        mode: "multiple",
                        options: _unref(dataTypes)
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ])
              ])
            ]),
            _: 1
          }, 8, ["model"]),
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: saveDiagnosisRules
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(getLanguage)('保存')), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_a_form, {
            model: _unref(reportRuleForm),
            name: "basic",
            autocomplete: "off",
            layout: "inline",
            "label-col": { style: { width: '100px' } }
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(getLanguage)('周报月报配置')), 1)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_a_tabs, {
                  activeKey: _unref(factorySettingTabActiveKey),
                  "onUpdate:activeKey": _cache[2] || (_cache[2] = ($event: any) => (_isRef(factorySettingTabActiveKey) ? (factorySettingTabActiveKey).value = $event : factorySettingTabActiveKey = $event)),
                  onChange: _unref(onChangeFactorySettingTab)
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(factoryList), (item, key) => {
                      return (_openBlock(), _createBlock(_component_a_tab_pane, { key: key }, {
                        tab: _withCtx(() => [
                          _createElementVNode("span", null, [
                            _createVNode(_component_bank_outlined),
                            _createTextVNode(" " + _toDisplayString(_unref(getTranslation)(item.factoryName)), 1)
                          ])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["activeKey", "onChange"])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(getLanguage)('报告生成策略')), 1),
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_a_form_item, {
                    label: _unref(getLanguage)('是否生成报告'),
                    name: "alarmTactics"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_25, [
                        _createVNode(_component_a_radio_group, {
                          name: "radioGroup",
                          value: _unref(reportRuleForm).reportRule.enabled,
                          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_unref(reportRuleForm).reportRule.enabled) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio, { value: false }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(getLanguage)('否')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_radio, { value: true }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(getLanguage)('是')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_component_a_form_item, {
                    label: "",
                    name: "deadline"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_27, _toDisplayString(_unref(getLanguage)('每月第')), 1),
                      _cache[24] || (_cache[24] = _createTextVNode("  ")),
                      _createVNode(_component_a_input_number, {
                        min: 1,
                        max: "28",
                        disabled: !_unref(reportRuleForm).reportRule.enabled,
                        value: _unref(reportRuleForm).reportRule.dayOfMonth,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_unref(reportRuleForm).reportRule.dayOfMonth) = $event))
                      }, null, 8, ["disabled", "value"]),
                      _cache[25] || (_cache[25] = _createTextVNode("  ")),
                      _createElementVNode("span", _hoisted_28, _toDisplayString(_unref(getLanguage)('天生成月报')), 1)
                    ]),
                    _: 1,
                    __: [24,25]
                  }),
                  _createVNode(_component_a_form_item, {
                    label: "",
                    name: "deadline"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_29, _toDisplayString(_unref(getLanguage)('每周第')), 1),
                      _cache[26] || (_cache[26] = _createTextVNode("  ")),
                      _createVNode(_component_a_input_number, {
                        min: 0,
                        max: "6",
                        disabled: !_unref(reportRuleForm).reportRule.enabled,
                        value: _unref(reportRuleForm).reportRule.dayOfWeek,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_unref(reportRuleForm).reportRule.dayOfWeek) = $event))
                      }, null, 8, ["disabled", "value"]),
                      _cache[27] || (_cache[27] = _createTextVNode("  ")),
                      _createElementVNode("span", _hoisted_30, _toDisplayString(_unref(getLanguage)('天生成周报')) + "( " + _toDisplayString(_unref(getLanguage)('范围')) + " 0 - 6)", 1)
                    ]),
                    _: 1,
                    __: [26,27]
                  })
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createVNode(_component_a_form_item, {
                    label: "",
                    name: "deadline"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_32, _toDisplayString(_unref(getLanguage)('第')), 1),
                      _cache[28] || (_cache[28] = _createTextVNode("  ")),
                      _createVNode(_component_a_input_number, {
                        min: 0,
                        max: "23",
                        disabled: !_unref(reportRuleForm).reportRule.enabled,
                        value: _unref(reportRuleForm).reportRule.dayOfHour,
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_unref(reportRuleForm).reportRule.dayOfHour) = $event))
                      }, null, 8, ["disabled", "value"]),
                      _cache[29] || (_cache[29] = _createTextVNode("  ")),
                      _createElementVNode("span", _hoisted_33, _toDisplayString(_unref(getLanguage)('小时生成报告')), 1)
                    ]),
                    _: 1,
                    __: [28,29]
                  })
                ])
              ])
            ]),
            _: 1
          }, 8, ["model"]),
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: saveReportRuleSettings
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(getLanguage)('保存')), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createVNode(_component_a_form, {
            model: _unref(diagnosisForm),
            name: "diagnosisForm",
            autocomplete: "off",
            layout: "inline",
            "label-col": { style: { width: '140px' } }
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, _toDisplayString(_unref(getLanguage)('推送账号配置')), 1)
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createVNode(_component_a_tabs, {
                  activeKey: _unref(factorySettingTabActiveKey),
                  "onUpdate:activeKey": _cache[7] || (_cache[7] = ($event: any) => (_isRef(factorySettingTabActiveKey) ? (factorySettingTabActiveKey).value = $event : factorySettingTabActiveKey = $event)),
                  onChange: _unref(onChangeFactorySettingTab)
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(factoryList), (item, key) => {
                      return (_openBlock(), _createBlock(_component_a_tab_pane, { key: key }, {
                        tab: _withCtx(() => [
                          _createElementVNode("span", null, [
                            _createVNode(_component_bank_outlined),
                            _createTextVNode(" " + _toDisplayString(_unref(getTranslation)(item.factoryName)), 1)
                          ])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["activeKey", "onChange"])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, _toDisplayString(_unref(getLanguage)('企业微信')), 1),
                _createElementVNode("div", _hoisted_40, [
                  _createVNode(_component_a_form_item, {
                    label: _unref(getLanguage)('企业id'),
                    name: "corpId"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: _unref(workWxForm).workWxSettings.corpId,
                        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_unref(workWxForm).workWxSettings.corpId) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _createVNode(_component_a_form_item, {
                    label: _unref(getLanguage)('企业secret'),
                    name: "corpSecret"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: _unref(workWxForm).workWxSettings.corpSecret,
                        "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_unref(workWxForm).workWxSettings.corpSecret) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _createVNode(_component_a_form_item, {
                    label: _unref(getLanguage)('应用AgentId'),
                    name: "agentId"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: _unref(workWxForm).workWxSettings.agentId,
                        "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_unref(workWxForm).workWxSettings.agentId) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _createVNode(_component_a_form_item, {
                    label: _unref(getLanguage)('群聊id'),
                    name: "chatId"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: _unref(workWxForm).workWxSettings.chatId,
                        "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_unref(workWxForm).workWxSettings.chatId) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _createVNode(_component_a_form_item, {
                    label: _unref(getLanguage)('消息标题'),
                    name: "messageTitle"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: _unref(workWxForm).workWxSettings.messageTitle,
                        "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_unref(workWxForm).workWxSettings.messageTitle) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ])
              ])
            ]),
            _: 1
          }, 8, ["model"]),
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: saveWorkWxForm
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(getLanguage)('保存')), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_45, [
          _createVNode(_component_a_form, {
            model: _unref(systemInfo),
            name: "basic",
            autocomplete: "off",
            layout: "inline",
            "label-col": { style: { width: '120px' } }
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, _toDisplayString(_unref(getLanguage)('安全策略配置')), 1)
              ]),
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, _toDisplayString(_unref(getLanguage)('账号策略')), 1),
                _createElementVNode("div", _hoisted_50, [
                  _createVNode(_component_a_form_item, {
                    label: _unref(getLanguage)('图形码验证'),
                    name: "captcha"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_51, [
                        _createVNode(_component_a_radio_group, {
                          name: "captcha",
                          value: _unref(systemInfo).captcha,
                          "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_unref(systemInfo).captcha) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio, { value: true }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(getLanguage)('启用')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_radio, { value: false }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(getLanguage)('关闭')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _createElementVNode("div", _hoisted_52, [
                  _createVNode(_component_a_form_item, {
                    label: _unref(getLanguage)('错误锁定'),
                    name: "errorPwdLock"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_53, [
                        _createVNode(_component_a_radio_group, {
                          name: "errorPwdLock",
                          value: _unref(systemInfo).errorPwdLock,
                          "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_unref(systemInfo).errorPwdLock) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio, { value: true }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(getLanguage)('启用')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_radio, { value: false }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(getLanguage)('关闭')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_a_form_item, {
                    label: "",
                    name: "deadline"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_54, _toDisplayString(_unref(getLanguage)('第2')), 1),
                      _cache[30] || (_cache[30] = _createTextVNode("  ")),
                      _createVNode(_component_a_input_number, {
                        disabled: !_unref(systemInfo).errorPwdLock,
                        value: _unref(systemInfo).errorPwdCount,
                        "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_unref(systemInfo).errorPwdCount) = $event))
                      }, null, 8, ["disabled", "value"]),
                      _cache[31] || (_cache[31] = _createTextVNode("  ")),
                      _createElementVNode("span", _hoisted_55, _toDisplayString(_unref(getLanguage)('账号密码验证错误次后锁定')), 1)
                    ]),
                    _: 1,
                    __: [30,31]
                  }),
                  _createVNode(_component_a_form_item, {
                    label: "",
                    name: "deadline"
                  }, {
                    default: _withCtx(() => [
                      _cache[32] || (_cache[32] = _createTextVNode("   ")),
                      _createVNode(_component_a_input_number, {
                        disabled: !_unref(systemInfo).errorPwdLock,
                        value: _unref(systemInfo).errorPwdLockSecond,
                        "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_unref(systemInfo).errorPwdLockSecond) = $event))
                      }, null, 8, ["disabled", "value"]),
                      _cache[33] || (_cache[33] = _createTextVNode("  ")),
                      _createElementVNode("span", _hoisted_56, _toDisplayString(_unref(getLanguage)('秒')), 1)
                    ]),
                    _: 1,
                    __: [32,33]
                  })
                ]),
                _createElementVNode("div", _hoisted_57, [
                  _createVNode(_component_a_form_item, {
                    label: _unref(getLanguage)('自动登出'),
                    name: "autoLogout"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_58, [
                        _createVNode(_component_a_radio_group, {
                          name: "autoLogout",
                          value: _unref(systemInfo).autoLogout,
                          "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_unref(systemInfo).autoLogout) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio, { value: true }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(getLanguage)('启用')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_radio, { value: false }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(getLanguage)('关闭')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_a_form_item, {
                    label: "",
                    name: "deadline"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_59, _toDisplayString(_unref(getLanguage)('当')), 1),
                      _cache[34] || (_cache[34] = _createTextVNode("  ")),
                      _createVNode(_component_a_input_number, {
                        disabled: !_unref(systemInfo).autoLogout,
                        value: _unref(systemInfo).autoLogoutSecond,
                        "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_unref(systemInfo).autoLogoutSecond) = $event))
                      }, null, 8, ["disabled", "value"]),
                      _cache[35] || (_cache[35] = _createTextVNode("  ")),
                      _createElementVNode("span", _hoisted_60, _toDisplayString(_unref(getLanguage)('秒用户未操作时自动登出')), 1)
                    ]),
                    _: 1,
                    __: [34,35]
                  })
                ]),
                _createElementVNode("div", _hoisted_61, [
                  _createVNode(_component_a_form_item, {
                    label: _unref(getLanguage)('密码强制过期'),
                    name: "pwdExpire"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_62, [
                        _createVNode(_component_a_radio_group, {
                          name: "pwdExpire",
                          value: _unref(systemInfo).pwdExpire,
                          "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_unref(systemInfo).pwdExpire) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio, { value: true }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(getLanguage)('启用')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_radio, { value: false }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(getLanguage)('关闭')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_a_form_item, {
                    label: "",
                    name: "deadline"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_63, _toDisplayString(_unref(getLanguage)('当')), 1),
                      _cache[36] || (_cache[36] = _createTextVNode("  ")),
                      _createVNode(_component_a_input_number, {
                        disabled: !_unref(systemInfo).pwdExpire,
                        value: _unref(systemInfo).pwdExpireDay,
                        "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_unref(systemInfo).pwdExpireDay) = $event))
                      }, null, 8, ["disabled", "value"]),
                      _cache[37] || (_cache[37] = _createTextVNode("  ")),
                      _createElementVNode("span", _hoisted_64, _toDisplayString(_unref(getLanguage)('天后用户需强制修改密码')), 1)
                    ]),
                    _: 1,
                    __: [36,37]
                  })
                ]),
                _createElementVNode("div", _hoisted_65, [
                  _createVNode(_component_a_form_item, {
                    label: _unref(getLanguage)('密码历史限制'),
                    name: "pwdExpire"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_66, [
                        _createVNode(_component_a_radio_group, {
                          name: "pwdHistory",
                          value: _unref(systemInfo).pwdHistory,
                          "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((_unref(systemInfo).pwdHistory) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio, { value: true }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(getLanguage)('启用')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_radio, { value: false }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(getLanguage)('关闭')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_a_form_item, {
                    label: "",
                    name: "deadline"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_67, _toDisplayString(_unref(getLanguage)('不能设置')), 1),
                      _cache[38] || (_cache[38] = _createTextVNode("  ")),
                      _createVNode(_component_a_input_number, {
                        disabled: !_unref(systemInfo).pwdHistory,
                        value: _unref(systemInfo).pwdHistoryDay,
                        "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((_unref(systemInfo).pwdHistoryDay) = $event))
                      }, null, 8, ["disabled", "value"]),
                      _cache[39] || (_cache[39] = _createTextVNode("  ")),
                      _createElementVNode("span", _hoisted_68, _toDisplayString(_unref(getLanguage)('天使用过的密码')), 1)
                    ]),
                    _: 1,
                    __: [38,39]
                  })
                ])
              ])
            ]),
            _: 1
          }, 8, ["model"]),
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: saveSystemSetting
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(getLanguage)('保存')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ]))
}
}

})